/*
* @Author: 王春岩 <Bolt>
* @Date:   2017-04-24 20:03:53
* @Last Modified by:   Bolt
* @Last Modified time: 2017-05-10 14:40:02
*/

'use strict';

/** @type {String} 同步本地数据错误 */
export const SYNC_LOCAL_RECORDS_ERROR = 'SYNC_LOCAL_RECORDS_ERROR';

export const ET_QUIS_PROIDENT_DOLORE = 'et quis proident dolore';


/** @type {String} 401 OptimusNotLoginException 表示未登录 */
export const NOT_LOGIN = 'NOT_LOGIN';

/** @type {String} 402 OptimusNoPerssionExciption 表示无该角色的操作权限 */
export const NO_PERMISSION = 'NO_PERMISSION';

/** @type {String} 402 OptimusCrossShopException 表示该用户出现跨店请求操作，禁止访问 */
export const CROSS_SHOP = 'CROSS_SHOP';

/** @type {String} 402 OptimusLoginUserNotExistException 登录时该用户不存在 */
export const LOGIN_USER_NOT_EXIST = 'LOGIN_USER_NOT_EXIST';

/** @type {String} 402 OptimusLoginBadPasswordException 登录时用户密码错误 */
export const LOGIN_BAD_PASSWORD = 'LOGIN_BAD_PASSWORD';

/** @type {String} 403 OptimusUserForbiddenException 表示该用户被封禁使用 */
export const USER_FORBIDDEN = 'USER_FORBIDDEN';

/** @type {String} 404 OptimusPathNotExistException 表示该接口对应的optimus处理方法不存在 */
export const PATH_NOT_EXISTS = 'PATH_NOT_EXISTS';

/** @type {String} 404 OptimusItemNotExistException 表示应用内部对应的实体不存在，应用抛出该异常（如用户、车辆、店铺等） */
export const ITEM_NOT_EXISTS = 'ITEM_NOT_EXISTS';

/** @type {String} 417 OptimusParamMissException 表示缺失部分必要的参数 */
export const PARAM_MISS = 'PARAM_MISS';

/** @type {String} 417 OptimusParamValidationException 表示参数校验出错 */
export const PARAM_VALIDATION_ERR = 'PARAM_VALIDATION_ERR';

/** @type {String} 417 OptimusParamConvertException 表示框架参数处理时，参数类型转换出错 */
export const PARAM_CONVERT_ERR = 'PARAM_CONVERT_ERR';

/** @type {String} 500 表示框架层面拦截到未知错误，optimus框架拦截最顶层的Exception */
export const UNKNOW_EXCEPTION = 'UNKNOW_EXCEPTION';

/** @type {String} 504 OptimusTimeoutException 表示服务器网关超时 */
export const TIMEOUT = 'TIMEOUT';

export const VERIFY_CODE_ERROR = 'VERIFY_CODE_ERROR';



// WEBPACK FOOTER //
// ./src/const/const-api-error-code.js